const angular = require('angular');

const bannersService = require('./banners.service'),
    pageBannerStateService = require('./pagebanner-state.service'),
    { bannerComponentDefinition } = require('./banner.component'),
    { tobaccoBannerComponentDefinition } = require('./tobacco-banner.component');

angular.module('wowApp.shop')
    .service('BannersService', bannersService)
    .service('PageBannerStateService', pageBannerStateService)
    .component('wowBanner', bannerComponentDefinition)
    .component('wowTobaccoBanner', tobaccoBannerComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/banners/index.js